<nav-bar></nav-bar><hoc-search [bodyComponent]="contentComponent" page="visu"></hoc-search>